import AllRecord from './all-record'

export default function MyRecord() {
  return <AllRecord showMyRecord={true} />
}
